import React from 'react';
import dayjs from 'dayjs';
import { Empty } from '@maxtropy/components';
import type { Key } from '@maxtropy/components';

export enum RadioType {
  DAY = 1,
  MONTH = 2,
}

export interface SwipperListItem {
  id: Key;
  name: string;
  physicalUnitName: string;
  energyConsumption: number | null;
  momRatio: number | null;
}

export const getEmpty = (description?: string) => (
  <div style={{ width: '100%', height: 400, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <Empty description={description} />
  </div>
);

export const formatTime = (time: [dayjs.Dayjs, dayjs.Dayjs], radioType: RadioType) => {
  if (radioType === RadioType.DAY) {
    return {
      fromTime: time[0].format('YYYY-MM-DD'),
      toTime: time[1].format('YYYY-MM-DD'),
    };
  }
  return {
    fromTime: dayjs(time[0]).startOf('month').format('YYYY-MM-DD'),
    toTime: dayjs(time[1]).endOf('month').format('YYYY-MM-DD'),
  };
};
